"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function getScrollPosition() {
    if (typeof window === 'undefined') {
        return {
            x: 0,
            y: 0
        };
    }
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
}
function useScrollPosition(sensitivity) {
    var _React$useState = react_1.default.useState({
        x: 0,
        y: 0
    }), position = _React$useState[0], setScrollPosition = _React$useState[1];
    var fpsInterval = 1000 / (sensitivity || 100);
    react_1.default.useEffect(function () {
        if (typeof window === 'undefined')
            return;
        var requestRunning = null;
        var then = Date.now();
        var handleScroll = function handleScroll() {
            if (requestRunning) {
                window.cancelAnimationFrame(requestRunning);
            }
            requestRunning = window.requestAnimationFrame(function () {
                var now = Date.now();
                var elapsed = now - then;
                if (elapsed > fpsInterval) {
                    then = now - elapsed % fpsInterval;
                    setScrollPosition(getScrollPosition());
                }
            });
        };
        window.addEventListener('scroll', handleScroll);
        return function () {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return position;
}
exports.default = useScrollPosition;
